export default "__VITE_ASSET__n0X1YyHH__"